import { useContent } from '../../../../../redux/reducer/content';

// url - из ручки v3/catalog/productblockbysku
// link - из тмг v1/game/products
export default function useGetLink({ url, link, sku }) {
  const { params } = useContent();
  let href = url || link;
  const utm = params?.utm?.product;
  if (href && utm && sku) {
    href = href.split('?')[0] + utm + sku;
  }
  return href;
}
